import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import Layout from "./components/Layout";
import ProtectedRoute from "./components/ProtectedRoute";
import Dashboard from "./pages/Dashboard";
import Products from "./pages/Products";
import Invoices from "./pages/Invoices";
import Transactions from "./pages/Transactions";
import Warehouses from "./pages/Warehouses";
import Reports from "./pages/Reports";
import Scanner from "./pages/Scanner";
import Login from "./pages/Login";
import Signup from "./pages/Signup";
import AuthCallback from "./pages/AuthCallback";
import AdminLogin from "./pages/AdminLogin";
import AdminDashboard from "./pages/AdminDashboard";
import "@/App.css";

// Router component that handles auth callback detection
function AppRouter() {
  const location = useLocation();

  // Check URL fragment for session_id - must be synchronous (not in useEffect)
  // This prevents race conditions with ProtectedRoute
  if (location.hash?.includes("session_id=")) {
    return <AuthCallback />;
  }

  return (
    <Routes>
      {/* Public Routes */}
      <Route path="/login" element={<Login />} />
      <Route path="/signup" element={<Signup />} />
      <Route path="/auth/callback" element={<AuthCallback />} />

      {/* Admin Routes */}
      <Route path="/admin/login" element={<AdminLogin />} />
      <Route path="/admin" element={<AdminDashboard />} />

      {/* Protected Routes */}
      <Route
        path="/"
        element={
          <ProtectedRoute>
            <Layout />
          </ProtectedRoute>
        }
      >
        <Route index element={<Dashboard />} />
        <Route path="products" element={<Products />} />
        <Route path="invoices" element={<Invoices />} />
        <Route path="transactions" element={<Transactions />} />
        <Route path="warehouses" element={<Warehouses />} />
        <Route path="reports" element={<Reports />} />
        <Route path="scanner" element={<Scanner />} />
      </Route>
    </Routes>
  );
}

function App() {
  return (
    <BrowserRouter>
      <Toaster 
        position="top-right" 
        richColors 
        theme="dark"
        toastOptions={{
          style: {
            background: '#151923',
            border: '1px solid #334155',
            color: '#F8FAFC',
          },
        }}
      />
      <AppRouter />
    </BrowserRouter>
  );
}

export default App;
